"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var requireCoursesFromMap_1 = require("../utils/requireCoursesFromMap");
var courseOptionsFromCourseMap_1 = require("../utils/courseOptionsFromCourseMap");
exports.default = function (allCourses, courseMap) {
    var validations = {
        validation: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, mathCoursesMap, 'endorsement-math-base', 1),
        options: courseOptionsFromCourseMap_1.default(courseMap, mathCoursesMap, 1, 'endorsement-math-base-options')
    };
    return validations;
};
var mathCoursesMap = {
    'algebra ii': 1,
    precalculus: 1,
    'advanced quant reasoning': 1,
    'indep study in math': 1,
    'discrete math for prblm solvng': 1,
    'ap statistics': 1,
    'ap computer science a': 1,
    'engineering mathematics': 1,
    'discrete math for comp science': 1,
    /* new courses added 2018-06-26 */
    "colge prep course mathematics": 1,
    "fundamentals of comp science": 1,
    "ib computer science, highr lvl": 1,
    "ib computer science, std level": 1,
    "ib further mthematics high lvl": 1,
    "ib mathematical studies stan.": 1,
    "ib mathematics higher level": 1,
    "ib mathematics standard level": 1,
    "linear algebra": 0.5,
    "multivariable calculus": 1,
    "number theory": 0.5,
    "statistics": 1,
    "strategic learn f/hs math": 1,
    "biotechnology i": 1,
    "ap physics 1: algebra based": 1,
    "ap chemistry": 1,
    "ap environmental science": 1
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/endorsementBaseMath/index.js
// module id = 451
// module chunks = 22